<script lang="ts">
    import {onMount} from "svelte";
    import {resolveImageByUrl} from "$lib/helpers/universalCategoryImageByUrlResolver";

    // univerzální kategorie jako vstup
    export let universal_categories;
    

    
    // název aktuální kategorie
    export let current_category_name;

    // privátní proměnná, která bude obsahovat vybrané kategorie na základě filtru níže
    let selected_categories: any[] = [];
    
    // při načtení komponenty provedeme filtr na základě parametrů
    onMount(function () {
        // řekněme, že pokud kategorie je "vse", tak se zobrazí katergorie filtry
        switch (current_category_name) {
            case "all":
                selected_categories = universal_categories.filter((category: any) => 
                    category.url === "baterie" || category.url === "gufera");
                break;
            case "motor":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "vzduchove_filtry" || category.url === "palivova_soustava" || category.url === "svicky");
                break;
            case "variator":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "valecky" || category.url === "uni_naradi" || category.url === "cisteni");
                break;
            case "brzdy":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "uni_brzdy" || category.url === "kapaliny" || category.url === "cisteni");
                break;
            case "elektro":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "baterie" || category.url === "uni_elektro" || category.url === "zarovky");
                break;
            case "dily":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "lanka" || category.url === "palivova_soustava" || category.url === "srouby");
                break;
            case "kapotaz":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "zrcatka" || category.url === "gripy" || category.url === "srouby");
                break;
            case "styl":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "kufry" || category.url === "uni_doplnky" || category.url === "zabezpeceni");
                break;
            case "osvetleni":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "zarovky" || category.url === "blinkry" || category.url === "baterie");
                break;
            case "vyfuk":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "dily_na_vyfuk" || category.url === "uni_elektro" || category.url === "samolepky");
                break;
               // doplnit ventilky až bude přidaná kategorie univerzálních, zatim davam 2x pneumatiky
            case "pneumatiky":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "pneumatiky" || category.url === "ventilky" || category.url === "cisteni");
                break;
            case "naradi":
                selected_categories = universal_categories.filter((category: any) =>
                category.url === "uni_naradi" || category.url === "srouby" || category.url === "cisteni");
                break;
            default:
                // Defaultně se vyberou první tři kategorie
                selected_categories = universal_categories.filter((category: any) => 
                category.url === "oleje" || category.url === "samolepky" || category.url === "doplnky");
                break;
                
        }
    });
</script>

{#if selected_categories}

<section class="my-12 border-t border-gray-200">
    <h3 class="my-12 w-full text-center text-2xl font-bold">
        <span class="block sm:inline-block">Nenašli jste potřebný díl?</span>
        <span class="block sm:inline-block">Zkuste univerzální díly</span>
    </h3>

    <div class="flex flex-wrap items-center sm:flex-nowrap sm:justify-center sm:text-center">
        <!-- smyčka pro každou kategorii -->
        {#each selected_categories as category}
            <a
                href={"/univerzalni-dily/" + category.url + "/"}
                title="Seznam náhradní dílů pro {category.name} skútru"
                class="m-3 ml-0 inline-block w-[48%] border border-gray-200 p-4 text-center font-bold shadow-md sm:ml-3 sm:w-52 sm:text-lg"
        >
            <div class="block flex h-16 w-full flex-nowrap items-center">
                <img src={resolveImageByUrl(category) } class="mx-auto w-auto" style="max-width: 110px;" alt={category.name} />
            </div>
            <span class="mt-4 inline-block w-auto"> {category.name} </span>
        </a>
        {/each}

    </div>
</section>

{/if}
